import { useEffect, useRef, useCallback } from 'react';

export function useInactivityLogout(onLogout, timeoutMinutes = 15) {
  const timeoutRef = useRef(null);
  const TIMEOUT_MS = timeoutMinutes * 60 * 1000;

  const resetTimer = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      console.log('User inactive - logging out');
      onLogout();
    }, TIMEOUT_MS);
  }, [onLogout, TIMEOUT_MS]);

  useEffect(() => {
    // Events that indicate user activity
    const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];

    // Reset timer on any activity
    const handleActivity = () => {
      resetTimer();
    };

    // Add event listeners
    events.forEach(event => {
      document.addEventListener(event, handleActivity);
    });

    // Start the timer
    resetTimer();

    // Cleanup
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      events.forEach(event => {
        document.removeEventListener(event, handleActivity);
      });
    };
  }, [resetTimer]);
}
